module.exports = __webpack_public_path__ + "img/address-black.b5697e31.svg";